// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import '@/assets/css/normalize.min.css'
import Vant from 'vant'
import axios from 'axios'
import 'vant/lib/index.css'

Vue.config.productionTip = false

axios.defaults.baseURL = 'http://gwadmin.xunlugame.com/'
Vue.prototype.$http = axios

Vue.use(Vant)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js